// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sAZBa","content":"styles_content__15HHU"};